import * as ApiModels from '@typings/api-models';
import * as DocumentApiModels from '@/tsClient/servers/noodleDocuments/document-api-models';
import File from '@/components/DesignLibrary/File';
import CaretRight from '@components/Icons/CaretRight';
import classNames from 'classnames';

import s from './PacerDocumentRow.module.scss';
import SecondaryActions from '../DesignLibrary/SecondaryActions';

type Props = {
  onClick: () => void;
  onRemoveDocument: (compiledDocumentId: string) => void;
  selected: boolean;
  compiledDocument:
    & Pick<ApiModels.UserWorkflowDocument, 'id' | 'referenceId' | 'referenceType' | 'templateReferenceType'| 'title' | 'integrationSlug' | 'integrationFileName'>
    & {
      document: Pick<DocumentApiModels.Document, 'id' | 'mimeType' | 'fileName' | 'createdAt'> | null;
    }
};

const PacerDocumentRow: React.FC<Props> = ({ compiledDocument, onClick, onRemoveDocument, selected }) => {
  const isEmpty = !compiledDocument.document;

  return (
    <button
      className={classNames(s['row-container'], selected && s.selected)}
      onClick={onClick}
    >
      {compiledDocument.document && !isEmpty
        && <File document={{
          createdAt: compiledDocument.document.createdAt,
          fileName: compiledDocument.integrationFileName || compiledDocument.document.fileName,
          id: compiledDocument.document.id,
          mimeType: compiledDocument.document.mimeType,
          uploadedAt: '',
          uploadedBy: { name: null },
        }} />}
      <SecondaryActions
        compact
        ariaLabel='Document Options'
        position='bottom-right'
        options={[
          { destructive: true, value: 'Remove' },
        ]}
        onSelect={value =>
        {
          if (value === 'Remove') {
            onRemoveDocument(compiledDocument.id);
          }
        }}
      />
      <CaretRight size={12} />
    </button>
  );
};

export default PacerDocumentRow;
